import { UnstyledButton } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import classes from './GetApps.module.css';

export default function GetAppsNavButton({
  active,
  onClick,
}: {
  active: boolean;
  onClick: () => void;
}) {
  return (
    <UnstyledButton
      className={classes.navButton}
      data-active={active || undefined}
      onClick={onClick}
    >
      <IconDownload size={20} stroke={2} />
      Get apps
    </UnstyledButton>
  );
}
